import React from "react";
import {
  productPrice, pdpPriceBox, compAtPrice, voucherBadge,
  specificBadgeProd
} from "./style.mod.scss";
import Money from "components/money";
import locale from "locales";
import getImagePath from "helpers/get-image-path";

const ProductPrice = ({ totalPrice, discountBadge, currentVariant, content }) => {
  const { price, compareAtPrice } = currentVariant?.store;
  const variantBadge = currentVariant?.variantBadge;
  const productBadge = content?.specificBadge;
  const badge = variantBadge ? variantBadge : productBadge;

  return (
    <div className={pdpPriceBox}>
      <span className={productPrice}>
        {content?.accessoiresCategory == "set" ? totalPrice == 0 ? `0${locale.products.currency}`
          : <Money value={totalPrice} currency={price.currencyCode} /> :
          <Money value={price} currency={price.currencyCode} />}
        <span className={compAtPrice}><Money value={compareAtPrice} /></span>
      </span>
      {(compareAtPrice > 0 && discountBadge) &&
        <span className={voucherBadge}>{locale.products.youSave}{" "}
          <Money value={compareAtPrice - price} />
        </span>}
      {(productBadge || variantBadge) && <div className={specificBadgeProd}><img src={getImagePath(badge)} alt={badge?.alt} /></div>}
    </div>
  );
};

export default ProductPrice;